import { LEAD_REPORTS_REQUEST, LEAD_REPORTS_SUCSSES } from './leadReportsData.actions';
import { LeadReportsStoreState, LeadReportsStoreModels } from './leadReportsData.state';
import { Action as NgRxAction } from '@ngrx/store'
import { getLeadReportsStoredData } from './leadReportsData.compare';

export interface Action extends NgRxAction {
  payload?: LeadReportsStoreModels
}

const initialLeadReportsState: LeadReportsStoreState = {
  leadReports: []
}

export function LeadReportsReducer(state = initialLeadReportsState, action: Action): LeadReportsStoreState {

  switch(action.type){
    case LEAD_REPORTS_REQUEST: {
      return {...state};
    }
    case LEAD_REPORTS_SUCSSES: {

      if(action?.payload){
        const results = getLeadReportsStoredData(state.leadReports,action.payload.reportType,action.payload.addedFilters);

        if(results.index > -1){
          state.leadReports[results.index] = action.payload;
        }else{
          state.leadReports.push(action.payload);
        }
      }

      return {...state};
    }
    default: {
      return state;
    }
  }
}
